import React, { useEffect, useState } from 'react'

interface CoundownProps {
    setHasExpired: (o: boolean) => void
    duration: number
    reset: boolean
    startOn: number
}

const Countdown: React.FC<CoundownProps> = ({ setHasExpired, duration, reset, startOn }) => {
    const [displayTime, setDisplayTime] = useState<string>()

    useEffect(() => {
        function startTimer(t: number) {
            setHasExpired(false)
            let timer = t
            let minutes = 0
            let seconds = 0
            let strMinutes = startOn.toString()
            let strSecounds = '00'
            const refreshId = setInterval(() => {
                minutes = Math.floor(timer / 60)
                seconds = timer % 60

                strMinutes = minutes < 10 ? `0${minutes}` : minutes.toString()
                strSecounds = seconds < 10 ? `0${seconds}` : seconds.toString()

                setDisplayTime(`${strMinutes}:${strSecounds}`)

                if (--timer < 0) {
                    timer = duration
                    clearInterval(refreshId)
                    setHasExpired(true)
                }
            }, 1000)
            setDisplayTime(`${strMinutes}:${strSecounds}`)
        }
        if (reset) {
            startTimer(duration || 2 * 60)
        }
        return () => {}
    }, [duration, reset, setHasExpired, startOn])

    return <span>{displayTime}</span>
}

export default Countdown
